import React from "react";
import { Button } from "react-bootstrap";
import {
  MdFirstPage,
  MdLastPage,
  MdArrowBackIos,
  MdArrowForwardIos,
} from "react-icons/md";

export default function Pagination({ table }) {
  return (
    <div className="pagination pagination-responsive ">
      <Button
        variant="outline-secondary"
        size="sm"
        className="border-0"
        onClick={() => table.setPageIndex(0)}
        disabled={!table.getCanPreviousPage()}
      >
        <MdFirstPage size={20} />
      </Button>

      <Button
        variant="outline-secondary"
        size="sm"
        className="border-0"
        onClick={() => table.previousPage()}
        disabled={!table.getCanPreviousPage()}
      >
        <MdArrowBackIos />
      </Button>

      <span>
        Stran{" "}
        <strong>
          {table.getState().pagination.pageIndex + 1} / {table.getPageCount()}
        </strong>
      </span>

      <Button
        variant="outline-secondary"
        size="sm"
        className="border-0"
        onClick={() => table.nextPage()}
        disabled={!table.getCanNextPage()}
      >
        <MdArrowForwardIos />
      </Button>

      <Button
        variant="outline-secondary"
        size="sm"
        className="border-0"
        onClick={() => table.setPageIndex(table.getPageCount() - 1)}
        disabled={!table.getCanNextPage()}
      >
        <MdLastPage size={20} />
      </Button>

      <span>Pojdi na:</span>

      <input
        type="number"
        className="form-control form-control-sm"
        style={{ width: "80px" }}
        min={1}
        max={table.getPageCount()}
        onChange={(e) => {
          const page = e.target.value ? Number(e.target.value) - 1 : 0;
          table.setPageIndex(page);
        }}
      />

      <select
        className="form-select form-select-sm"
        style={{ width: "100px" }}
        value={table.getState().pagination.pageSize}
        onChange={(e) => table.setPageSize(Number(e.target.value))}
      >
        {[10, 20, 30, 40, 50, 100].map((size) => (
          <option key={size} value={size}>
            {size} Vrstic
          </option>
        ))}
      </select>
    </div>
  );
}
